import SecureResidenceSubFrame from './SecureResidenceSubFrame';
import { panelByFrameId } from '../../utils/secureResidenceFlow';

const panel = panelByFrameId('frame-26')!;

export default function Frame26() {
  return <SecureResidenceSubFrame panel={panel} />;
}
